import { noop } from "@omni/utils/function.utils";
import { cn } from "@omni/utils/styles";

import { Fade } from "../Fade/fade.component";
import { AlertProps } from "./alert.props";

const Alert = ({
    children,
    className,
    color = "success",
    toggle,
    closeClassName,
    isOpen = true,
    fade = true,
    closeAriaLabel,
    ref,
    transition = {
        baseClass: "fade",
        timeout: 150,
        addEndListener: noop,
        unmountOnExit: true
    },
    ...attributes
}: AlertProps) => {
    const alertTransition = {
        ...transition,
        baseClass: fade ? transition.baseClass : "",
        timeout: fade ? transition.timeout : 0
    };

    return (
        <Fade
            {...attributes}
            {...alertTransition}
            addEndListener={transition.addEndListener || noop}
            tag={"div"}
            className={cn(className, "alert", `alert-${color}`, {
                "alert-dismissible": toggle
            })}
            in={isOpen}
            role="alert"
            ref={ref}
        >
            {toggle ? (
                <button
                    type="button"
                    className={cn("close", closeClassName)}
                    aria-label={closeAriaLabel}
                    onClick={toggle}
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            ) : null}
            {children}
        </Fade>
    );
};

export { Alert };
